// src/data/questions.js
const questions = [
  {
    id: "q1",
    text: `1. (a) The table contains four statements about programming languages.
    Choose one box in in each row to identify whether each statement describes a low-level programming language or a high-level programming language.
    [Display image1: \\src\\assets\\1.png]

      (b) The variables num1 and num2 store integers.
      Write pseudocode to add the integers stored in num1 and num2. Store the result in a variable with the identifier total
      
      (c) Read the following pseudocode algorithm:
      01 start = 3
      02 do
      03 print(start)
      04 start = start - 1
      05 until start == -1
      06 print("Finished")
      Complete the following trace table for the given algorithm.
      [Display image2: \\src\\assets\\1.png]
`,
    marks: 8,
    summary: "Identifying Programming Languages, Writing Pseudocode, and Completing Trace Tables.",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  "Question: Marketing Mix Adaptation in Small Businesses
Scenario: A family-owned bakery has been operating in a town center for 15 years, but recently noticed a decline in customer visits despite maintaining their traditional offerings and pricing structure.
Question: Explain one way the marketing mix of this small bakery may need to change in response to shifting consumer needs.
Marks: 3 marks total
1 mark for identifying a valid element of the marketing mix to adapt (product, price, place, or promotion)
1 mark for explaining a specific change that addresses shifting consumer needs
1 mark for relating the change to the bakery's current situation (declining customer visits)

Marking Instructions:
Check Marketing Mix Element: Verify if the student has correctly identified one of the 4Ps (product, price, place, or promotion) that needs adaptation. Award 1 mark for correctly identifying a relevant element.
Check Specific Change: Assess if the student has explained a specific, practical change that addresses shifting consumer needs. Award 1 mark for a clear and feasible suggestion.
Check Contextual Application: Evaluate if the student has related their suggested change to the bakery's specific situation of declining customer visits despite traditional offerings. Award 1 mark for proper contextualization.

Final Scoring:
Marketing Mix Element: 1 mark for correctly identifying a relevant element to adapt
Specific Change: 1 mark for explaining a specific, practical change
Contextual Application: 1 mark for relating the change to the bakery's current situation

Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

*Student Response:*`
  },


  {
    id: "q2",
    text: `2. This pseudocode algorithm totals all the numbers in the 0-indexed array scores
            01 total = 0
            02 for scoreCount = 1 to scores.length – 1
            03 scores[scoreCount] = total + total
            04 next scoreCount
            05 print(total)
            The function length returns the number of elements in the array.
            The algorithm contains several errors.
            Two types of errors in a program are syntax and logic errors.
            (a) State what is meant by a syntax error and a logic error.
      
      (b) Identify two logic errors in the pseudocode algorithm.
          Write the refined line to correct each error.`,
    marks: 6,
    summary: "Identifying and Correcting Logic Errors in a Pseudocode Algorithm",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  "Question: How does increased competition influence decision making in small businesses?

Scenario: Emma has been running a small bookshop in her town for five years. Recently, a large chain bookstore opened nearby, and an online retailer has begun offering next-day delivery to her area. Discuss how Emma's business decision making may be affected by this increased competition.

Marks: 6 marks total
- 2 marks for identifying relevant decision-making areas affected by competition
- 2 marks for analyzing specific impacts on these decision areas
- 2 marks for evaluating potential responses to the competitive threats

Marking Instructions:
Check Decision Areas Identified: Verify if the student has identified at least two relevant decision-making areas that would be affected by increased competition (e.g., pricing, product range, customer service, marketing, operational efficiency). Award up to 2 marks based on relevance and completeness.

Check Impact Analysis: Assess if the student has analyzed how the specific competitive threats (chain bookstore and online retailer) would impact Emma's decision-making in the identified areas. Award up to 2 marks based on depth of analysis and application to the scenario.

Check Response Evaluation: Evaluate if the student has discussed potential strategic responses Emma might consider and how these would affect her decision-making process. Award up to 2 marks based on feasibility of suggestions and critical evaluation.

Final Scoring:
Decision Areas: Up to 2 marks for identifying relevant decision-making areas
Impact Analysis: Up to 2 marks for analyzing specific impacts on these decision areas
Response Evaluation: Up to 2 marks for evaluating potential responses

Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

*Student Response:*`
 },

  {
    id: "q3",
    text: `3. An insertion sort is one type of sorting algorithm.
              A student has written a pseudocode algorithm to perform an insertion sort on a 1D array names.
              names = ["Kareem", "Sarah", "Zac", "Sundip", "Anika"]
              for count = 1 to names.length – 1
              pos = count
              while (pos > 0 and names[pos] < names[pos – 1])
              temp = names[pos]
              names[pos] = names[pos – 1]
              names[pos – 1] = temp
              pos = pos – 1
              endwhile
              next count
            (a) Describe the purpose of the variable temp in the insertion sort pseudocode algorithm.
    
    (b)  An insertion sort contains a nested loop; a loop within a loop. In this pseudocode algorithm the outer loop is a count-controlled loop and the inner loop is a condition-controlled loop.
 Explain why the inner loop needs to be a condition-controlled loop.`,
    marks: 4,
    summary: "Insertion Sort Algorithm: Purpose of Variables and Loop Control",
initialCode: ``,
  prompt:  `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  "Question: Importance of Cash to Businesses

Scenario: ""On Your Wheels"" is a small bicycle shop that has seen rapid growth in customer demand over the past six months. Despite increasing sales, the owner is concerned about the business's financial situation. Outline one reason why maintaining adequate cash reserves would be important to ""On Your Wheels.""

Marks: 2 marks total
- 1 mark for identifying a valid reason for maintaining adequate cash reserves
- 1 mark for explaining how this specifically relates to ""On Your Wheels"" situation

Marking Instructions:
Check Reason Identified: Verify if the student has identified a valid reason why maintaining adequate cash reserves is important for a business (e.g., managing cash flow gaps, funding growth/expansion, handling emergencies or unexpected expenses, taking advantage of opportunities, maintaining supplier relationships). Award 1 mark for a correct and relevant reason.

Check Application to Scenario: Assess if the student has clearly explained how their identified reason specifically applies to ""On Your Wheels"" situation of rapid growth despite financial concerns. Award 1 mark for a clear and contextual explanation that links to the bicycle shop's circumstances.

Final Scoring:
Reason: 1 mark for identifying a valid reason for maintaining cash reserves
Application: 1 mark for explaining how this specifically relates to the scenario

Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

*Student Response:*`
  },


  {
    id: "q4",
    text: `4. Charlie is developing an adding game. The rules of the game are:
          • the player is asked 3 addition questions
          • each question asks the player to add together two random whole numbers between 1 and 10 inclusive
          • if the player gets the correct answer, 1 is added to their score
          • at the end of the game their score is displayed.
          (a) Validating inputs can reduce errors when a program is being run.
          Identify two methods of validation and explain how they can be used on this game.
    
    (b) Write an algorithm to play this game. The rules are repeated from the start of the question here:
        • the player is asked 3 addition questions
        • each question asks the player to add together two random whole numbers between 1 and 10 inclusive
        • if the player gets the correct answer, 1 is added to their score
        • at the end of the game their score is displayed. `,
    marks: 12,
    summary: "Creating and Validating an Addition Game Algorithm",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
"Question: Jamie and Sara are considering opening a graphic design studio together as equal business partners. They have the skills and initial capital but are unsure about the best legal structure for their venture. Explain one disadvantage of starting their small business as a partnership.

Marks: 3 marks total
1 mark for identifying a valid disadvantage of a partnership structure
1 mark for explaining the disadvantage clearly
1 mark for relating the disadvantage specifically to Jamie and Sara's graphic design studio context

Marking Instructions:
Check the Disadvantage: Verify if the student has identified a valid disadvantage of a partnership business structure (e.g., unlimited liability, profit sharing, decision-making conflicts, etc.). Award 1 mark for a correct disadvantage.

Check the Explanation: Assess if the student has clearly explained how the identified disadvantage functions or manifests in a partnership. Award 1 mark for a clear and correct explanation.

Check the Application: Evaluate if the student has related the disadvantage specifically to Jamie and Sara's graphic design studio context. Award 1 mark for meaningful application to the scenario.

Final Scoring:
Disadvantage Identification: 1 mark for correctly identifying a valid disadvantage of partnerships
Explanation of Disadvantage: 1 mark for clearly explaining the disadvantage
Application to Scenario: 1 mark for relating the disadvantage to Jamie and Sara's specific business context

Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

*Student Response:*`
  },


  {
    id: "q5",
    text: `5. OCR Security Services is a company that installs intruder alarm systems in commercial buildings.
          The systems use a computer that is connected to the door sensors and window sensors.
          The following data is stored in the system: 
          [Display image3: \\src\\assets\\1.png]
          (a) Below is a table showing some variables within the program.
          Choose one box in each row to identify the most appropriate data type for each variable.
          [Display image4: \\src\\assets\\1.png]


    
    (b) The alarm has an algorithm that decides whether to sound the alarm by checking the data that is stored in the following three variables.
      • SystemArmed
      • DoorSensorActive
      • WindowSensorActive

      The alarm will only sound when the alarm has been activated and one or both of the door and window sensors are activated. When the system needs to sound the alarm it calls the pre-written procedure SoundAlarm()

      Write a program that checks the data in the variables and calls SoundAlarm() when appropriate.
      You must use either:
      • OCR Exam Reference Language, or
      • A high-level programming language that you have studied.
    
    (c) The alarm system can also have motion sensors. Each type of sensor has a code. The code for each sensor is given in the table:
        [Display image5: \\src\\assets\\1.png]
        A program is written to reset the sensors. The program:
        • asks the user to enter the code for the sensor they want to reset
        • calls the prewritten function CheckSensorCode() to check whether the code entered is a valid code
        • the sensor number is read as input if the code is valid and the function ResetSensor() is called for the sensor
        01 sensorType = input("Enter code of the type of sensor to reset")
        02 if(CheckSensorCode(sensorType)) then
        03 sensorNumber = input("Please input the number of the sensor to reset")
        04 sensorID = sensorType + sensorNumber
        05 ResetSensor(sensorID)
        06 endif

        (i) Give the identifier of a variable used in the program. 

        (ii) Identify the data type of the data returned by the function CheckSensorCode().

        (iii) Give the line number that contains a function call. 

    (d) The alarm system has a log that stores a record each time a sensor is triggered. This is called an event. The record format is given in the table:
        [Display image6: \\src\\assets\\1.png]
        Write an SQL statement to display the sensor IDs of the door sensors that have been triggered for more than 20 seconds.

    (e) OCR Security Services need to identify the total number of seconds the sensors have been activated on a specific date.
        The data from the database table events is imported into the program written in a highlevel programming language.
        The program stores the data in a two-dimensional (2D) string array with the identifier arrayEvents
        The data to be stored is shown in the table.
        [Display image8: \\src\\assets\\1.png]
        In this table, the value of events[1, 1] contains "MS1".

        (i) Write a program that:
          • asks the user to input a date
          • totals the number of seconds sensors have been activated on the date input
          • outputs the calculated total in an appropriate message including the date, for
          example:
          Sensors were activated for 40 seconds on 05/02/2023
          You must use either:
          • OCR Exam Reference Language, or
          • A high-level programming language that you have studied.

`,
    marks: 20,
    summary: "Programming and Algorithms for a Security Alarm System",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
Question: Evaluate the Profit Impact of a Business Acquisition (12 Marks)

Scenario:
SportStyle PLC, a leading UK sportswear retailer with 2,500 stores across 20 countries, has recently announced its acquisition of UrbanKicks, a competing footwear retailer with 65 UK stores. Both companies target the 'athleisure' market of 16-24 year olds. UrbanKicks has been operating at a loss for the past year and was purchased for £95 million. The Competition and Markets Authority has launched an investigation into this acquisition, citing concerns about consumer choice and supplier relationships.

Read the extract below and evaluate whether SportStyle's acquisition of UrbanKicks will allow the company to increase its profit.

Extract:
SportStyle PLC is a multinational sports, fashion and footwear retailer based in the UK. It owns several brands including StreetFoot and TeamKit. It has over 2,500 stores in 20 different countries. Most of its brands target the 'athleisure' market. This market consists of 16–24 year olds who choose to wear sportswear outside of the gym. It uses targeted online advertising to direct customers to one of its websites, such as www.sportstyle.co.uk. It also sponsors a prominent UK boxing champion and a Premier League football team.

In March 2023, SportStyle announced that it was acquiring loss-making, rival sports footwear retailer UrbanKicks for £95 million. UrbanKicks, like SportStyle, had its headquarters in the North West of England and was founded by a former SportStyle director, James Barton. UrbanKicks had 65 stores in the UK in similar locations to SportStyle. UrbanKicks also targeted the 'athleisure' market and sold identical trainer brands to SportStyle such as Nike, Adidas and Puma. SportStyle brands itself as the 'Trainer Authority', in an attempt to compete with its main rival, FitnessOutlet.

In July 2023, the Competition and Markets Authority (CMA) announced an investigation into the acquisition. It expressed concerns about the impact that the takeover might have on consumers and suppliers.

Marks: 12 marks total
- 3 marks for analysis of economies of scale and cost reduction opportunities
- 3 marks for evaluation of market share expansion and revenue growth potential
- 3 marks for assessment of operational synergies and efficiency improvements
- 3 marks for consideration of the CMA investigation and potential risks

Marking Instructions:
Check the Economies of Scale Analysis: Verify if the student has analyzed how the acquisition might lead to economies of scale (bulk purchasing, shared distribution networks, etc.). Award up to 3 marks based on depth and relevance of analysis.

Check the Market Share Evaluation: Assess if the student has evaluated how the acquisition impacts market share and revenue growth potential (elimination of competitor, access to new customers, cross-selling opportunities). Award up to 3 marks based on quality of evaluation.

Check the Operational Synergies Assessment: Verify if the student has assessed potential operational synergies (combining management teams, eliminating duplicate functions, shared resources). Award up to 3 marks based on comprehensiveness of assessment.

Check the Risk Consideration: Assess if the student has considered the CMA investigation and other risks (regulatory obstacles, integration challenges, financial implications of acquiring a loss-making business). Award up to 3 marks based on depth of risk consideration.

Final Scoring:
Economies of Scale Analysis: Up to 3 marks
Market Share Evaluation: Up to 3 marks
Operational Synergies Assessment: Up to 3 marks
Risk Consideration: Up to 3 marks

Explanation to Student: Provide feedback on the student's response, highlighting strengths in their evaluation of profit impact factors and explaining any missing or incorrectly evaluated elements. If full marks are not awarded in any category, explain what was needed for a complete analysis. Emphasize the importance of balanced evaluation considering both potential benefits and risks to profit.

*Student Response: *`
  },


];

export default questions;
